<template>
    <v-snackbars :objects.sync="internal_value">
        <template #action="{ close }">
            <v-btn
                @click="close"
                color="transparent"
                depressed
                fab
                small
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbars>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import VSnackbars from 'v-snackbars'
import locale_mixin from '@/mixins/common/locale_mixin'

export default {
    name: 'TheSnackbars',
    props: {},
    mixins: [locale_mixin],
    components: {
        VSnackbars,
    },
    data() {
        return {
            internal_value: [],
        }
    },
    computed: {
        ...mapGetters([]),
        ...mapState(['snackbar_messages']),
    },
    watch: {
        snackbar_messages(messages) {
            const message = messages[messages.length - 1]
            message['message'] = this.translate(message['text'])
            this.internal_value.push(message)
        },
    },
    methods: {
        ...mapActions([]),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
}
</script>
<style scoped></style>
